import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { TextareaWithConfirm, RadioOptionsWithConfirm, IQuestion, TitleAndEditButton } from 'shared-components';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useCustomNavigate } from '../../../../../hooks/useCustomNavigate';
import { useTranslation } from "react-i18next";

const VisaPrepFormUniEnrolmentPage2 = (props: any) => {
    const { t } = useTranslation('common');
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE7_2));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);
  const { navigateTo } = useCustomNavigate();
  const onEdit = () => navigateTo(`${props.params.offerId}/history/step-4`);

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { qualificationAsProofOfEnglish, qualificationAndCountry } = visaPrepForm;

  // constants
  const currentStep = 2;
  const steps = 3;

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      qualificationAndCountry,
      qualificationAsProofOfEnglish,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, qualificationAndCountry, qualificationAsProofOfEnglish]);

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'University Enrolment'}
    >
      <TitleAndEditButton
        title={t('common:youHaveIndicatedThatYouHaveNotSu')}
        onClick={onEdit}
      />

      <RadioOptionsWithConfirm
        key={VQ.QUALIFICATION_AS_PROOF_OF_ENGLISH}
        id={VQ.QUALIFICATION_AS_PROOF_OF_ENGLISH}
        label={t('common:areYouUsingAPreviousQualificatio')}
        onClick={(question: IQuestion) => onChange(VQ.QUALIFICATION_AS_PROOF_OF_ENGLISH, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: qualificationAsProofOfEnglish === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: qualificationAsProofOfEnglish === false,
          },
        ]}
      />

      {qualificationAsProofOfEnglish === true ? (
        <TextareaWithConfirm
          key={VQ.QUALIFICATION_AND_COUNTRY}
          id={VQ.QUALIFICATION_AND_COUNTRY}
          value={qualificationAndCountry}
          label={t('common:pleaseStateYourAcademicQualifica')}
          onChange={(evt: any) => onChange(VQ.QUALIFICATION_AND_COUNTRY, evt.currentTarget.value)}
        />
      ) : null}
    </QuestionPage>
  );
};
export default VisaPrepFormUniEnrolmentPage2;
